"use strict";

var LoggerInstance = require("js-logger").get("ContactUsApi");

var AbstractApi = require("./AbstractApi");

var ContactUsApi = class extends AbstractApi {
	submitContactUsRequest(contactUsRequestData) {
		return this.post({
			data: contactUsRequestData,
			url: "/api/contactus",
			reCAPTCHA: true
		});
	}
};

module.exports = new ContactUsApi();



// WEBPACK FOOTER //
// ./Javascript/api/ContactUsApi.jsx